import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";


export default function Footer() {
  const currentPath = useLocation();
  const [showUI, setShowUI] = useState(true);
  const theme = useTheme();
  const brandSurface = theme.brand?.surface || theme.palette.primary.main;
  const textOnSurface = theme.brand?.textOnSurface || theme.palette.primary.contrastText;

  useEffect(() => {
    const path = currentPath.pathname;
    const excludePath = ['/login', '/register']
    if (excludePath.includes(path)) {
      setShowUI(false)
    }
    else setShowUI(true)
  }, [currentPath])


  if (!showUI) {
    return null;
  }

  return (
    <>
      <Box
        component="footer"
        sx={{
          width: "100%",
          m: 0,
          p: 0,
          pb: "env(safe-area-inset-bottom, 0px)",
          mt: "auto",
          backgroundColor: brandSurface,
          minHeight: { xs: "min(7.4vh, 64px)", md: "auto" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          borderTop: "3px solid #B01840",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: brandSurface,
            width: "100%",
            pt: { xs: 0.35, md: 1.15 },
            pb: { xs: 0.45, md: 1.215 * 0.9 },
            px: { xs: 2, md: 3 },
          }}
        >
          <Box
            sx={{
              color: textOnSurface,
              textAlign: "center",
              width: "100%",
              maxWidth: 520,
              px: { xs: 1, md: 2 },
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "0.62rem", sm: "0.88rem", md: "0.9rem" },
                fontWeight: 500,
                lineHeight: 1.35,
                color: textOnSurface,
                whiteSpace: { xs: "nowrap", sm: "normal" },
                width: "100%",
                textAlign: "center",
              }}
            >
              &copy; {new Date().getFullYear()} Bezohminds. All Rights Reserved.
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
